/**
 * UC-11 extension: SubmitPolicyForReview
 */
import type { Policy } from '../../../types/policy';
import { PolicyStatus } from '../../../types/policy';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { IPolicyManager } from '../../domain/ports/IPolicyManager';

export interface SubmitPolicyForReviewInput {
  policyId: string;
}

export interface SubmitPolicyForReviewOutput {
  ok: boolean;
  policy?: Policy;
  error?: string;
}

export interface SubmitPolicyForReviewDependencies {
  policyManager: IPolicyManager;
  logger?: IAppLogger;
}

export class SubmitPolicyForReviewUseCase {
  constructor(private readonly deps: SubmitPolicyForReviewDependencies) {}

  execute(input: SubmitPolicyForReviewInput): SubmitPolicyForReviewOutput {
    try {
      const policy = this.deps.policyManager.updatePolicy(input.policyId, {
        status: PolicyStatus.UnderReview,
      });

      this.deps.logger?.log('debug', 'policy.submitted_for_review', {
        policyId: policy.id,
      });

      return { ok: true, policy };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      return { ok: false, error: message };
    }
  }
}